import type { ProgramAsins, PublishProgramAsins } from '../types';

/**
 * Transforms program Asins data structure for publishing by combining primary and backup Asins
 * into a single array while maintaining the primary ASIN as the first element.
 *
 * @param {ProgramAsins[]} programAsins - Array of program data containing primary and backup Asins
 * @returns {PublishProgramAsins[]} Array of transformed program data with combined Asins
 */

export const generatePublishProgramAsins = (programAsins: ProgramAsins[]): PublishProgramAsins[] =>
  programAsins.map((programAsin) => ({
    asins: [
      programAsin.primaryAsin,
      ...programAsin.backupAsins.filter((asin) => asin && asin.trim() !== ''),
    ],
    program: programAsin.program,
  }));
